module.exports = __webpack_public_path__ + "img/icon-arrowdown.06cddd5a.svg";